import { useQuery } from "@tanstack/react-query";
import { api } from "@/core/api/client";

export interface Season {
  id: number;
  name: string;
  starts_at: string;
  ends_at: string;
  scoring: string;
  puzzle_slugs: string[];
}

export interface Standing {
  participant: string;
  is_team: boolean;
  points: number;
  puzzles_solved: number;
  total_elapsed_ms: number;
  best_rank: number | null;
  per_puzzle: Record<string, number>;
}

export interface StandingsPayload {
  season: Season;
  /** False for `sum_of_ranks` (lowest total wins), true for points-like scoring. */
  higher_is_better: boolean;
  standings: Standing[];
}

export function useSeasons() {
  return useQuery({
    queryKey: ["seasons"],
    queryFn: () => api<{ seasons: Season[]; strategies: string[] }>("/api/seasons/"),
  });
}

export function useSeasonStandings(id: string) {
  return useQuery({
    queryKey: ["seasons", id, "standings"],
    queryFn: () => api<StandingsPayload>(`/api/seasons/${id}/standings/`),
    enabled: Boolean(id),
  });
}
